/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    'Něco se pokazilo. Zkuste to znovu za pár minut.',
  'goal-content.goal-about-content.description-edit-button': 'Upravit',
  'goal-content.goal-about-content.description-title': 'Popis',
  'goal-content.goal-about-content.placeholder-description':
    'Stručně popište, proč je tento cíl důležitý a jak se měří jeho úspěch, aby sledující získali základní informace.',
  'goal-content.goal-content-about.edit-description-error-title': 'Popis cíle se nepodařilo upravit',
  'goal-content.goal-content-update-date.edited': '(upraveno)',
  'goal-content.goal-content-update-date.edited-tooltip': 'Upraveno {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(naposledy upravil(a) {name})',
  'goal-content.goal-content-updates.add-update': 'Přidat aktualizaci',
  'goal-content.goal-content-updates.archived': 'Archivováno',
  'goal-content.goal-content-updates.at-risk': 'V ohrožení',
  'goal-content.goal-content-updates.cancelled': 'Zrušeno',
  'goal-content.goal-content-updates.completed': 'Dokončeno 🎉',
  'goal-content.goal-content-updates.date-changed': 'Změna data',
  'goal-content.goal-content-updates.edit-update': 'Upravit',
  "goal-content.goal-content-updates.for-date'": 'pro {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Nejnovější aktualizace',
  'goal-content.goal-content-updates.missed-update-message': 'Nebyla zveřejněna žádná aktualizace',
  'goal-content.goal-content-updates.new-due-date': 'Nový termín splnění',
  'goal-content.goal-content-updates.new-state': 'Nový stav',
  'goal-content.goal-content-updates.no-updates-description': 'Pro tento cíl tu zatím nejsou žádné aktualizace.',
  'goal-content.goal-content-updates.off-track': 'Ve skluzu',
  'goal-content.goal-content-updates.old-due-date': 'Starý termín splnění',
  'goal-content.goal-content-updates.old-state': 'Starý stav',
  'goal-content.goal-content-updates.on-track': 'Podle plánu',
  'goal-content.goal-content-updates.paused': 'Pozastaveno',
  'goal-content.goal-content-updates.pending': 'Čekající',
  'goal-content.goal-content-updates.previous-updates-title': 'Předchozí aktualizace',
  'goal-content.goal-content-updates.share-update': 'Sdílet',
  'goal-content.goal-content-updates.status-changed': 'Stav byl změněn',
  'goal-content.goal-content-updates.write-update-button': 'Napsat aktualizaci',
  'goal-content.goal-update-composer.modal-title': 'Zveřejněte svou aktualizaci.',
  'goal-content.goal-update-composer.post-button-label': 'Zveřejnit aktualizaci',
};
